import React from "react";
import { useTranslation } from "react-i18next";
import InputAutoresize from "../../../../common/components/form/InputAutoresize.jsx";

const VK = "ReturnPolicy"; // VariablesKey
export default function ReturnPolicy(props) {
    const { t } = useTranslation();

    const { set, variables } = props;

    function onChange(event) {
        let value = event.target.value;
        event.type === "blur" && (value = value.trim());
        set({ ...variables, [VK]: value });
    }

    return (
        <div className="grid-gap-20 align-content-start">
            <h3>{t("Specify Rerurn Policy")}:</h3>
            <p>{t("You need to specify how your customer can return your product and get back their money.")}</p>

            <InputAutoresize
                onChange={onChange}
                onBlur={onChange}
                value={variables[VK] || ""}
                // placeholder={t("Generated by GPT")}
                fullWidth
                multirow
                rows={8}
            />
        </div>
    );
}
